module.exports = __webpack_public_path__ + "img/botanalysis.4a160c79.svg";